import { SERVICES_DATA } from '@shared/data/services';

export const DEFAULT_HEADER_MENU_ROUTES = ['/services', '/datasets', '/tasks'];

export const HEADER_MENU_ROUTES = new Set([
  ...DEFAULT_HEADER_MENU_ROUTES,
  '/data',
  '/businesses',
  '/businesses/export/history',
]);

const DATA_SECTION_ROUTES = [
  '/businesses',
  '/businesses/export/history',
  '/businesses/export/success',
  '/catalog',
  '/datasets',
];

export const normalizeHeaderMenuRoute = (route) => {
  if (typeof route !== 'string') return null;

  const trimmedRoute = route.trim();
  if (!trimmedRoute) return null;

  const [pathname] = trimmedRoute.split('?');
  const normalizedRoute = pathname.startsWith('/') ? pathname : `/${pathname}`;

  return normalizedRoute.length > 1 ? normalizedRoute.replace(/\/+$/, '') : normalizedRoute;
};

export const getHeaderMenuRoutes = (routes) => {
  const sourceRoutes = Array.isArray(routes) ? routes : DEFAULT_HEADER_MENU_ROUTES;
  const seenRoutes = new Set();

  return sourceRoutes.reduce((acc, route) => {
    const normalizedRoute = normalizeHeaderMenuRoute(route);

    if (!normalizedRoute || !HEADER_MENU_ROUTES.has(normalizedRoute) || seenRoutes.has(normalizedRoute)) {
      return acc;
    }

    seenRoutes.add(normalizedRoute);
    acc.push(normalizedRoute);

    return acc;
  }, []);
};

export const showUserName = (email) => {
  if (!email) return email;
  const name = email.split('@')[0];
  return name.charAt(0).toUpperCase() + name.slice(1);
};

export const countMenuChildren = (menu) =>
  menu?.items?.reduce((acc, item) => {
    if (!item?.key) return acc;
    const childCount = item.children ? countMenuChildren({ items: item.children }) : 0;
    return acc + 1 + childCount;
  }, 0) || 0;

export const getActiveKey = (pathname, headerMenuRoutes) => {
  if (
    pathname.startsWith('/account') ||
        pathname.startsWith('/billing') ||
        pathname.startsWith('/invoices')
  ) {
    return null;
  }

  const normalizedRoutes = getHeaderMenuRoutes(headerMenuRoutes).sort((a, b) => b.length - a.length);
  const normalizedPath = normalizeHeaderMenuRoute(pathname);

  if (
    normalizedRoutes.includes('/data') &&
    DATA_SECTION_ROUTES.some(route => normalizedPath === route || normalizedPath?.startsWith(`${route}/`))
  ) {
    return '/data';
  }

  const matchedRoute = normalizedRoutes.find(route => normalizedPath === route || normalizedPath?.startsWith(`${route}/`));

  if (matchedRoute) return matchedRoute;

  if (
    pathname.startsWith('/api-docs') ||
        pathname.startsWith('/api-key') ||
        pathname.startsWith('/usage-history') ||
        pathname.startsWith('/integrations')
  ) {
    return 'api-integrations';
  }

  const isServiceRoute = Object.values(SERVICES_DATA).some(service =>
    pathname.startsWith(`/${service.key}`)
  );

  if (isServiceRoute) {
    return normalizedRoutes.includes('/services') ? '/services' : null;
  }

  return null;
};
